class WIquickAtc extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.clickOnSingleVariant();
  }
  clickOnSingleVariant() {
      // const productForm = this.querySelector('form');
      const VariantId = this.querySelector('.ProductForm__Option').getAttribute('data-variant-id');
      // productForm.addEventListener("submit", async (e) => {
      //   e.preventDefault();
      // });
      this.querySelector('.ProductForm__AddToCart').addEventListener("click", async (e) => {
        const Mspan = this.querySelector('.Ma-span'); 
        const spinner = this.querySelector('.loading-overlay__spinner'); 
        spinner.classList.remove('hidden');
        Mspan.classList.add('hidden');
        
        let formData = {
          items: [{ id: VariantId, quantity: 1 }],
        };
        await fetch("/cart/add", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        
        let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
        let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
        
        
        if (loadingCartBlock != null) {
            loadingCartBlock.style.display = "block";
        }
        if (emptyCart != null) {
            emptyCart.style.display = "none";
        }
        const wiCartDrawerElement = document.querySelector('wi-cartdrawer');
        if (wiCartDrawerElement) {
          wiCartDrawerElement.openCart();
          wiCartDrawerElement.updateCart();
        }
        
        spinner.classList.add('hidden');
        Mspan.classList.remove('hidden');
        
      });
    }
    
}
customElements.define("ma-productitem", WIquickAtc);